import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Button, EmotionBreakpoint, BrandUtil, FormatSkuData } from 'dw-us-ui';
import { DescriptionTab } from 'dw-us-ui/src/bundles/product-bundle';
import styled from '@emotion/styled';
import { LoadingIcon } from 'dw-us-ui';
import { clickEventDL } from 'dw-global/apps/dataLayer';

const ProductContainer = styled.div`
      display: flex;
	  padding: 30px 0;
      .product-img-container {
        flex: 0 0 24%;
        max-width: 24%;
        padding: 0 15px;
        margin-bottom: 15px;
		justify-content: center;
		align-items: center;
		display: flex;
		.img-responsive{
			max-height: 135px;
		}
		}
		.err-message{
			width: 100%;
		}
      }
      .product-title-container {
        flex: 0 0 43%;
        max-width: 43%;
        text-align: left;
        font-size: 1.2rem;
        padding: 0 15px;
        .product-title-link {
          margin-bottom: 8px;
		  a {
			color: #3c3c3c;
		  }
        }
        p {
          font-size: 0.9rem;
        }
      }
      .product-details-container {
        flex: 0 0 33%;
        max-width: 33%;
		.sold-out-style{
			display: flex;
			justify-content: center;
			align-items: center;
			background:${({ brandTag }) => (brandTag === 'wsj' ? '#efefef' : '#e6e6e6')};
    		padding: 6px 0;
			text-transform: uppercase;
			font-weight: bold;
			font-size: ${({ brandTag }) => (brandTag === 'wsj' ? '14px' : '16px')};
            height:${({ brandTag }) => (brandTag === 'wsj' ? '30px' : '44px')};
            letter-spacing: ${({ brandTag }) => (brandTag === 'wsj' ? '2px' : '1px')};

		}
        .product-details-inner-container{
          background: transparent;
          border: 1px solid #CCCCCC;
          padding: 20px 20px 15px 20px;
          border-radius: 0px;
		  .btn-container{
			width: 100%;
			button{
				width: 100%;
			}
		}
		  .best-price{
			font-size: 1.1rem;
			font-weight: bold;
			margin-top: 2px;
			margin-bottom: 5px;
			text-align: left;
			}
			.on-sale-tag{
				width: 25px;
				margin-left: 5px;
			}
			}
		  .product-details{
			display: flex;
			flex-direction: column;
          	text-align: left;
			font-size: 16px;
			gap: 3px;
			font-size: 15px;
			.sale-price-style{
				color:${({ theme }) => theme.button.primary.backgroundColor};
        font-weight: bold;
			}
      .list-price-style{
        font-weight: normal;

      }
      >
		  	.bottle-price{
				display: flex;
				width: 66%;
				justify-content: space-between;
			  .num-of-bottles{
				color:black;
			  }
			  .sale-price-per-bottle{
				font-weight: bold;
			  }
			}
			.sale-price{
				font-weight: bold;
    			color: #cf004f;
			}
		}
		.saving-percent{
			color: #cf004f;
			font-weight: bold;
			text-align: left;
			margin-top: 5px;
			font-size: 16px;
		}
          .product-buy{
            color:${({ theme }) => theme.button.primary.backgroundColor};
            font-weight: bold;
          }
          .add-to-cart-container{
            margin-top: 10px;
            display: flex;
            align-items: center;
			button {
				${EmotionBreakpoint('notDesktop')} {
					font-size: 14px;
    				padding: 0 10px;
				}
			}
            .input-container{
              width: 50px;
              height: 45px;
              margin-right: 28px;
			  ${EmotionBreakpoint('notDesktop')} {
				margin-right: 15px;
				}
              input {
                width: 50px;
                height: 100%;
				background-clip: padding-box;
				background-color: #fff;
				border: 1px solid #f6f6f6;
				padding: 0.375rem 0.75rem;
				text-align: center;
				color: #333333;
				display: block;
				font-weight: 400;
				transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
              }
			  input: focus {
				background-color: #fff;
				border-color: #ff5092;
				box-shadow: 0 0 0 0.2rem rgb(207 0 79 / 25%);
				color: #666;
				outline: 0;
			  }
            }

          }
        }
      }
	  @media (min-width: 561px) and (max-width: 768px) {
		.add-to-cart-container {
			display: flex;
			flex-direction: column;
			gap: 14px;
		}
	}
	@media  (max-width: 560px) {
		display: flex;
        flex-direction: column;
        align-items: center;
        gap: 20px;
		.product-title-container{
            max-width: 100%;
        }
		.product-details-container{
			max-width: 100%;
			flex: unset;
			width: 100%;
		}
		.product-img-container {
			max-width: 60%;
		}
		}
	}
`;

const Product = ({ fields, winePlanSubscription }) => {
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const OUT_OF_STOCK = 'out_of_stock';
  const itemCode = fields?.itemCode;
  const initialState = {
    inputValue: 1,
    btnText: 'Add to Cart',
    disabled: false,
    isVpAlreadyAvailable: false,
    availabilityStatus: true,
    setSchemeId: '',
  };
  const [state, setState] = useState(initialState);
  const [isProductAvailable, setProductAvailable] = useState(true);
  const [isLoading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/api/product/item/${itemCode}`)
      .then(res => {
        const { response } = res?.data;
        let numberOfBottles;
        let salePricePerBottle;
        let salePrice;
        let savingsPercent;
        let savingPrice;
        let listPrice;
        let preSellItem;
        let sku;
        if (itemCode.includes('B', 'C', 'T') && response?.skus?.length > 1) {
          response?.skus.some(item => {
            if (item?.itemCode === itemCode) {
              sku = item;
              return true;
            }
          });
        } else {
          sku = response?.skus[0];
        }
        let winePlanSchemeId = response?.skus[0]?.schemeDetails[0]?.schemeId;
        let isVpAlreadExist =
          winePlanSubscription?.length &&
          winePlanSubscription?.some(winePlan => {
            if (winePlan?.schemeId === winePlanSchemeId) {
              return true;
            }
          });
        let availabilityStatus = response?.inventoryInfo?.summaryAvailabilityStatus === OUT_OF_STOCK ? false : true;
        if (sku.itemCode === itemCode) {
          numberOfBottles = sku.numberOfBottles;
          salePrice = sku.salePrice;
          listPrice = sku.listPrice;
          salePricePerBottle = sku.salePricePerBottle;
          preSellItem = sku?.preSellItem;
          savingsPercent =
            sku.listPrice === sku.salePrice ? false : ((sku.salePrice - sku.salePricePerBottle) / sku.salePrice) * 100;
          savingPrice = sku.listPrice === sku.salePrice ? false : (sku.listPrice - sku.salePrice).toFixed(0);
          savingsPercent = savingsPercent > 5 ? savingsPercent.toFixed(0) + '%' : false;
        }
        let setSchemeId = sku?.schemeDetails?.length ? sku?.schemeDetails[0]?.schemeId : '';

        if (isVpAlreadExist) {
          setState({
            ...state,
            response,
            numberOfBottles,
            salePricePerBottle,
            salePrice,
            savingsPercent,
            savingPrice,
            listPrice,
            availabilityStatus,
            preSellItem,
            isVpAlreadyAvailable: isVpAlreadExist,
            btnText: preSellItem ? 'Reserve Today' : 'Add to Cart',
            setSchemeId,
          });
        } else {
          setState({
            ...state,
            response,
            numberOfBottles,
            salePricePerBottle,
            salePrice,
            savingsPercent,
            savingPrice,
            listPrice,
            availabilityStatus,
            preSellItem,
            btnText: preSellItem ? 'Reserve Today' : 'Add to Cart',
            setSchemeId,
          });
        }
        setLoading(false);
      })
      .catch(err => {
        setProductAvailable(false);
        setLoading(false);
      });
  }, []);

  const toggleReactMiniCart = () => {
    const reactMiniCart = document.getElementById('react-mini-cart-trigger-tool');

    // Trigger new mini cart
    if (window.isMiniCartEnabled === false || window.newHeaderFooterInitData.enableNewMiniCart === true) {
      return true;
    }

    if (reactMiniCart) {
      reactMiniCart.click();
      return true;
    }

    return false;
  };

  const triggerDLEvent = async addToCartData => {
    try {
      const {
        response: { lineItems },
      } = await fetch('/api/cart/list?validate=true').then(res => res.json());

      let event = '';
      if (lineItems.length > 0) {
        event = 'addToCart';
      } else {
        event = 'initiateCart';
      }
      fetch(`/api/product/item/${itemCode}`)
        .then(res => res.json())
        .then(({ response }) => {
          const quantity = 1;
          const action = 'add to cart';
          let productDetails = {
            product: response,
          };
          let productArray = [productDetails];
          productArray = FormatSkuData(productArray);
          productDetails = productArray?.product ? productArray : productArray[0];
          if (productDetails?.product) {
            const lineItem = addToCartData?.lineItems?.find(
              _lineItem => _lineItem?.lineItemIdentification?.itemCode === itemCode,
            );
            productDetails.product.additionalParams = {
              units: quantity,
              noBottles: quantity,
              price: lineItem?.itemPriceInfo?.salePrice,
              discount: lineItem?.itemPriceInfo?.savings,
            };
            productDetails.product.skus = undefined;
          }
          const dataLayerData = {
            cartContents: [
              {
                ...productDetails,
                additionalParams: {
                  units: quantity,
                  noBottles: quantity,
                },
              },
            ],
            itemcode: itemCode,
            quantity,
            price: addToCartData?.orderPriceInfo?.rawSubtotal,
            clickAction: action,
            name: action,
            clickLocation: 'vineyard-partner',
          };
          clickEventDL(event, dataLayerData);
        });
    } catch (error) {
      // to prevent any side affects on site
      console.error(error?.message);
    }
  };

  const MySvgIcon = () => (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 10C17.5 13.866 14.366 17 10.5 17V20C16.0228 20 20.5 15.5228 20.5 10C20.5 4.47715 16.0228 0 10.5 0C4.97715 0 0.5 4.47715 0.5 10H3.5C3.5 6.13401 6.63401 3 10.5 3C14.366 3 17.5 6.13401 17.5 10Z"
        fill="white"
      />
    </svg>
  );

  const addProductToCart = async productCode => {
    setState({ ...state, btnText: <MySvgIcon />, disabled: false });
    const url = `/api/cart/itemcode/${productCode}/1`;
    axios
      .put(url)
      .then(res => {
        let data = res?.data?.response;
        let lineItems = res?.data?.response.lineItems;
        let numItems = res?.data?.response.numItems;
        let total = data?.orderPriceInfo?.rawSubtotal;
        let itemPrice;

        triggerDLEvent(data);

        lineItems.forEach(item => {
          let lineItemCode = item?.lineItemIdentification?.itemCode;

          if (productCode === lineItemCode) {
            itemPrice = item.itemPriceInfo.salePrice.toString();
          }
        });

        miniCart.config.itemAdded = {
          itemCode: productCode,
          qty: state.inputValue,
          price: itemPrice,
        };
        miniCart.config.cartDetails = res?.data?.response;
        miniCart.updateEmbeddedCart('added', productCode, state?.inputValue);

        if (!toggleReactMiniCart()) addOnModal.isEligible(res?.data);

        let vpCurrentWinePlanItem = {
          vpItemCode: productCode,
          isAdded: true,
          schemeId: state?.setSchemeId,
        };

        let vpWinePlanItems = JSON.parse(localStorage.getItem('vpWinePlanItems'));
        let setVpWinePlanItems =
          vpWinePlanItems && vpWinePlanItems?.length
            ? [...vpWinePlanItems, vpCurrentWinePlanItem]
            : [vpCurrentWinePlanItem];
        localStorage.setItem('vpWinePlanItems', JSON.stringify(setVpWinePlanItems));
      })
      .catch(err => {
        var addToCartError = document.querySelector('#add-to-cart-error p');

        // Check if the element exists
        if (addToCartError) {
          if (
            err?.response?.data?.errorResponse?.message ===
            'Sorry, you can only order one wine plan introductory case. Please choose which one you would prefer.'
          ) {
            addToCartError.textContent =
              'Sorry, but you can only reserve one case of this wine when you become a Vineyard Partner.';
          } else {
            addToCartError.textContent = err?.response?.data?.errorResponse?.message;
          }
        }
        var addToCartErrorNotification = document.querySelector('#add-to-cart-error-notification');
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // Show error notification
        addToCartErrorNotification.style.display = 'block';

        // Fade out error notification after 5 seconds
        setTimeout(function () {
          addToCartErrorNotification.style.display = 'none';
        }, 5000);
      })
      .finally(() => {
        setState({
          ...state,
          btnText: state?.preSellItem ? 'Reserve Today' : 'Add to Cart',
          disabled: false,
        });
      });
  };

  // const inputChangeHandler = (e) => {
  // 	setState({
  // 		...state,
  // 		inputValue: e.target.value != '' ? e.target.value : 1,
  // 	});
  // };

  return (
    <>
      {!isLoading ? (
        <ProductContainer brandTag={brandTag}>
          {isProductAvailable ? (
            <>
              <div className="product-img-container">
                <a href={`/product/${state?.response?.name}/${state?.response?.itemCode}`}>
                  <img
                    src={state?.response?.largeImage}
                    onError={e => {
                      e.target.src = '/images/us/common/default_bottle_large.png';
                    }}
                    alt={'Bottles'}
                    className="img-responsive js-default-bottle-image-handler medium"
                  />
                </a>
              </div>
              <div className="product-title-container">
                <div className="product-title-link">
                  <a href={`/product/${state?.response?.name}/${state?.response?.itemCode}`}>
                    {state?.response?.webHeadline}
                  </a>
                </div>
                <p>
                  {state?.response && (
                    <DescriptionTab
                      productDetails={state?.response}
                      tabName="About This Wine"
                      gaCategory={'Single_Bottle_Product_Page'}
                      gaAction={'Product_Details'}
                    />
                  )}
                </p>
              </div>
              <div className="product-details-container">
                {state?.availabilityStatus ? (
                  <div className="product-details-inner-container">
                    <div className="product-details">
                      {state?.numberOfBottles !== 1 && state?.salePrice < state?.listPrice && (
                        <div className="product-buy">SAVE ${state?.savingPrice}</div>
                      )}
                      <div>
                        {state?.numberOfBottles} bottles -{' '}
                        {state?.numberOfBottles !== 1 && state?.salePrice < state?.listPrice && (
                          <strike>${state?.listPrice}</strike>
                        )}{' '}
                        <b className={state?.salePrice < state?.listPrice ? 'sale-price-style' : 'list-price-style'}>
                          ${state?.salePrice}
                        </b>
                      </div>
                      {state?.numberOfBottles != 1 && <div>(${state?.salePricePerBottle} per bottle)</div>}
                    </div>
                    <div className="add-to-cart-container">
                      {/* Removing the input field as instructed by lauren */}
                      {/* <div className='input-container'>
									<input
										maxlength='2'
										placeholder='1'
										id='qty'
										pattern='^[1-9]\d*$'
										min='1'
										max='99'
										type='tel'
										onChange={(event) => {
											inputChangeHandler(event);
										}}
									/>
								</div> */}
                      <div className="btn-container">
                        <Button
                          buttonType="primary"
                          buttonSize="small"
                          onClick={() => {
                            addProductToCart(itemCode);
                          }}
                          disabled={state.disabled}
                        >
                          {state.btnText}
                        </Button>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="sold-out-style">Sold Out</div>
                )}
              </div>
            </>
          ) : (
            <h2 class="primary-font-title err-message">
              Sorry, the item you're looking for isn't available right now.
            </h2>
          )}
        </ProductContainer>
      ) : (
        <div className="loader-style">
          <LoadingIcon />
        </div>
      )}
    </>
  );
};

export { Product };
